<template>
  <div class="__dropdown-menu" :class="{ 'mr-sm': marginRight }">
    <CMenu :position="position">
      <template v-slot:activator>
        <slot name="activator" />
      </template>

      <template v-slot:content>
        <CList>
          <template v-for="(item, index) in options">
            <CItem clickable :key="item.actionType" @click="handleClick(item.actionType)">
              <CItemSection avatar v-if="item.icon">
                <CIcon :name="item.icon" material />
              </CItemSection>

              <CItemSection>{{ item.label }}</CItemSection>
            </CItem>

            <CSeparator v-if="item.separate" :key="index" />
          </template>
        </CList>
      </template>
    </CMenu>
  </div>
</template>

<script>
import Vue from 'vue';
import CMenu from '@/components/uikit/CMenu';
import CList from '@/components/uikit/CList';
import CItem from '@/components/uikit/CItem';
import CItemSection from '@/components/uikit/CItemSection';
import CSeparator from '@/components/uikit/CSeparator';
import CIcon from '@/components/uikit/CIcon';

export default Vue.extend({
  name: 'DropdownMenu',
  components: { CMenu, CList, CItem, CItemSection, CSeparator, CIcon },
  props: {
    options: {
      type: Array,
      required: true,
    },
    position: String,
    marginRight: Boolean,
  },
  methods: {
    handleClick(actionType) {
      console.log(actionType);
      this.$emit('click', actionType);
    },
  },
});
</script>

<style lang="scss" scoped></style>
